<div class="container pb-4 pt-4">
  <app-breadcrumb currentRouteName="Tickets d'assistance"></app-breadcrumb>
  @if (!company) {
    <h1 class="pt-3 pb-2">Mes tickets d'assistance</h1>
  }
  @if (company) {
    <h1 class="pt-3 pb-2">Tickets d'assistance de ma structure</h1>
  }

  <div class="mb-2 d-flex align-items-center flex-wrap grid-gap-05rem" [class.has-search]="searchByContent">
    <button class="btn btn-primary text-nowrap" (click)="checkInfos = true">
      <fa-icon icon="plus-circle" class="d-inline-block d-md-none"></fa-icon>
      <span class="d-none d-md-inline-block">Déposer un ticket</span>
      <span class="d-inline-block d-md-none">&nbsp;Ticket</span>
    </button>
    <button class="btn btn-outline-primary" (click)="showCdt = true" ngbTooltip="Carnet de temps">
      <fa-icon [icon]="['far', 'calendar-alt']"></fa-icon>
    </button>

    <app-mobile-search (mobileSearch)="searchMobile($event)" helper="Rechercher un ticket"></app-mobile-search>

    <form class="d-none d-md-flex input-group pe-0 ps-0 position-relative" (submit)="changeSearch($event)" ngNoForm>
      <input [(ngModel)]="search.search" class="form-control" placeholder="Rechercher par mot(s) clé(s)">
      <button class="btn btn-primary" type="submit">
        <fa-icon icon="search"></fa-icon>
      </button>
      @if (searchByContent) {
        <div class="remove-search-icon" (click)="removeSearch()">
          <fa-icon icon="times"></fa-icon>
        </div>
      }
    </form>

    @if (searchByContent) {
      <span class="d-flex d-md-none mobile-search-info">
        {{ search.search }}
        <fa-icon class="d-block" icon="times" (click)="removeSearch()"></fa-icon>
      </span>
    }

    <app-toggle [class.d-none]="searchByContent" class="d-lg-none ms-auto" tooltipLeft="Mes tickets" iconLeft="user"
      [(enabled)]="company" (enabledChange)="changeCompany()"
    tooltipRight="Tickets de ma structure" iconRight="landmark"></app-toggle>

    <div [hidden]="searchByContent" class="d-none d-lg-block ms-auto">
      @if (!company) {
        <button (click)="company = !company; changeCompany()" class="btn btn-primary">
          <fa-icon icon="landmark"></fa-icon>
          Voir les tickets de ma structure
        </button>
      }
      @if (company) {
        <button (click)="company = !company; changeCompany()" class="btn btn-primary">
          <fa-icon icon="user"></fa-icon>
          Voir mes tickets
        </button>
      }
    </div>
  </div>

  @if ((versionsReady && ticketsReady)) {
    <div>
      @if (searchByContent) {
        <div class="d-flex">
          <div class="text text-info">
            {{ tickets.length }} résultat(s)
            <span class="d-none d-md-inline-block">
              pour des tickets contenant "{{ searchByContent }}"
            </span>
          </div>
          <app-toggle class="d-md-none d-block ms-auto" tooltipLeft="Mes tickets" iconLeft="user" [(enabled)]="company"
            (enabledChange)="changeCompany()"
          tooltipRight="Tickets de ma structure" iconRight="landmark"></app-toggle>
        </div>
      }
      <div class="d-flex justify-content-between flex-column flex-md-row">
        <ul ngbNav class="nav-tabs justify-content-between" (activeIdChange)="changeState($event)"
          [(activeId)]="search.state" [animation]="false">
          <li [ngbNavItem]="'open'">
            <a ngbNavLink class="portail-nav-link ps-0">
              Ouverts <span class="d-none d-md-inline">({{ (tickets | state:'open').length }})</span>
              <span class="text-light-grey d-md-none">{{ (tickets | state:'open').length }}</span>
            </a>
          </li>
          <li [ngbNavItem]="'closed'">
            <a ngbNavLink class="portail-nav-link">
              Fermés <span class="d-none d-md-inline">({{ (tickets | state:'closed').length }})</span>
              <span class="text-light-grey d-md-none">{{ (tickets | state:'closed').length }}</span>
            </a>
          </li>
          <li [ngbNavItem]="' '">
            <a ngbNavLink class="portail-nav-link">
              Tous <span class="d-none d-md-inline">({{ tickets.length }})</span>
              <span class="text-light-grey d-md-none">{{ tickets.length }}</span>
            </a>
          </li>
        </ul>
      </div>
      <div class="position-relative">
        <ls-dynamic-table
          class="hover-table"
          pagesize="10"
          [paginationTop]="true"
          [paginationBottom]="true"
          [paginate]="true"
          [(page)]="search.page"
          [(sortAsc)]="search.asc"
          [data]="tickets | state:search.state"
          [headers]="tableHeaders"
          [(currentSort)]="search.sort">
          <ng-template let-item>
            <td class="d-table-cell d-md-none fw-bold stretched-link" [class.todo]="item.state.indexOf('action client') !== -1">
              N°{{ item.number }} - {{ item.title }}
            </td>
            <td class="d-none d-md-table-cell" [class.todo]="item.state.indexOf('action client') !== -1">
              <a class="clickable-row" [routerLink]="item.number"></a>
              {{ item.number }}
            </td>
            <td [class.todo]="item.state.indexOf('action client') !== -1">
              <span class="d-none d-md-table-cell line-clamp-2" #el [ngbTooltip]="item.title"
                [disableTooltip]="el.scrollHeight <= el.clientHeight">
                {{ item.title }}
              </span>
            </td>
            <td [class.todo]="item.state.indexOf('action client') !== -1">{{ item.state | statedisplay }}</td>
            <td class="d-none d-md-table-cell" [class.todo]="item.state.indexOf('action client') !== -1">{{ item.queue }}</td>
            <td [class.todo]="item.state.indexOf('action client') !== -1">
              @if (getCategoryFromSlug(item.product); as cat) {
                <app-badge
                [label]="{id: 0, textcolor: cat.textcolor, backcolor: cat.backcolor, name: cat.name}"></app-badge>
              }
            </td>
            <td class="d-none d-lg-table-cell" [class.todo]="item.state.indexOf('action client') !== -1">{{ item.version | version }}</td>
            <td class="d-none d-lg-table-cell" [class.todo]="item.state.indexOf('action client') !== -1">{{ item.versionIntegration | versionintegration }}</td>
            <td class="d-table-cell d-md-none text-light-grey pb-2" [class.todo]="item.state.indexOf('action client') !== -1">Dernière mise à jour : {{ duration(item.changed) }}</td>
            <td class="text-nowrap d-none d-md-table-cell" [class.todo]="item.state.indexOf('action client') !== -1">{{ duration(item.created) }}</td>
            <a class="clickable-row" [routerLink]="item.number"></a>
          </ng-template>
        </ls-dynamic-table>
      </div>
    </div>
  } @else {
    @if (error) {
      <div>
        Le service de ticket de support est momentanément indisponible, merci de retenter l'opération dans quelques
        minutes.
      </div>
    }
    @if (!error) {
      <div>
        <div class="pt-5">
          <ls-spinner/>
        </div>
      </div>
    }
  }


  <app-ticket-read-info [(check)]="checkInfos"></app-ticket-read-info>
  <app-cdt-infos [(show)]="showCdt"></app-cdt-infos>
</div>
